// import { PayPalEnvironment } from 'ngx-paypal';

export const environment = {
  //**Production Setting */
  production: true,
  turnstileSiteKey: '0x4AAAAAACaKGwDqVfcUCk5J',
  storeAdmin_InksoftDesignUrl: 'https://api.merchloop.com/store/customizedproducts?designID=0',
  frontEnd_BaseUrl: 'https://login.merchloop.com/',
  baseUrl: 'https://api.merchloop.com/',
  // Migrated to Design Huddle: image columns store absolute Azure Blob URLs; no host prefix needed.
  imgBaseURL: '',
  masterProductImgBaseURL: '',
  api_url_inksoft: 'https://stores.inksoft.com/DS304263396/Api2',
  baseUrlShopifyApp: 'https://app.merchloop.com',
  paypalPublicKey: 'AUgdGuMIZ6OHJKxGvE9Di2tOsYaMuSLcmh_9Td1q-NaKb7EukH_hvFYKgB8ncksN0nB9BQWXJg3xYDk5',
  // paypalEnv: PayPalEnvironment.Production,
  prod: true,
  productCustomImageFolder: 'https://stokedmanagementdiag.blob.core.windows.net/productioncustomproductimages/',
  warehouseProductCustomImageFolder: 'https://stokedmanagementdiag.blob.core.windows.net/productionwarehouseproductimages/',
  assignOrderlog: 'https://stokedmanagementdiag.blob.core.windows.net/productionassignorderlog/',
  azureBlobCdnUrl: 'https://stokedmanagementdiag.blob.core.windows.net/',
  huddleLogoFolder: 'https://stokedmanagementdiag.blob.core.windows.net/productionhuddlelogo/',
  huddleBackgroundFolder: 'https://stokedmanagementdiag.blob.core.windows.net/productionhuddlebackground/',
  // Design Huddle Integration
  designHuddleEnabled: true,
  designHuddleEditorUrl: 'https://editor.designhuddle.com',
  designHuddleDomain: 'merchloop.designhuddle.com',
  designHuddleClientId: 'wq80d0zhhn6xkvfjofl3',
  designHuddleCategoryId: 4,
  // Customer Portal API
  customerPortalApiUrl: 'https://customerportal-customerportalapi-ameedfdfgyayh5ax.northcentralus-01.azurewebsites.net',
};
